<template>
  <div>
    <a-modal
      :title="info.isAdd ? '添加信息' : '修改信息'"
      v-model:visible="info.isShow"
      :footer="null"
      style="min-width: 800px"
    >
      <a-form :model="partnerform" ref="partnerform" :rules="rule5">
        <a-form-item
          label="考试科目"
          name="subjectNo"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select
            :model="partnerform.subjectName"
            :filter-option="filterOption"
            show-search
            allow-clear
          >
            <a-select-option value="1">1</a-select-option>
            <a-select-option value="2">2</a-select-option>
            <a-select-option value="1">1</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="考试时间"
          name="subjectName1"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-date-picker show-time :locale="locale">
            <template #renderExtraFooter>考试时间</template>
          </a-date-picker>
        </a-form-item>
        <a-form-item
          label="考试名额"
          name="certificateTypeId"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="partnerform.a"
            placeholder="请输入考试名额"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="考试条件"
          name="passScore"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select
            mode="multiple"
            v-model:value="partnerform.a"
            style="width: 100%"
            placeholder="Please select"
            @change="handleChange"
          >
            <a-select-option v-for="i in 25" :key="(i + 9).toString(36) + i">
              {{ (i + 9).toString(36) + i }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="服务模式"
          name="validity"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select v-model:value="partnerform.a">
            <a-select-option value="1">考试</a-select-option>
            <a-select-option value="2">培训+考试</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="考试费用"
          name="entryFee"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input-number
            v-model:value="partnerform.entryFee"
            placeholder="请输入报名费用"
            min="1"
            max="100000"
          ></a-input-number>
        </a-form-item>
        <a-form-item
          label="报名截止日期"
          name="entryFee"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-date-picker
            v-model:value="partnerform.entryFee"
            placeholder="请选择报名截止日期"
          />
        </a-form-item>
        <a-form-item
          label="考试密码"
          name="certificateTypeId"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-input
            v-model:value="partnerform.a"
            placeholder="请输入考试密码"
            allow-clear
          ></a-input>
        </a-form-item>
        <a-form-item
          label="考场名称"
          name="certificateTypeId"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <a-select
            :model="partnerform.subjectName"
            :filter-option="filterOption"
            show-search
            allow-clear
            placeholder="请选择考场名称"
          >
            <a-select-option value="1">1</a-select-option>
            <a-select-option value="2">2</a-select-option>
            <a-select-option value="1">1</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="考场地址"
          name="certificateTypeId"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <span>{{partnerform.subjectName}}</span>
        </a-form-item> 
        <a-form-item
          label="场次ID"
          name="certificateTypeId"
          :label-col="{ span: 4, offset: 1 }"
          :wrapper-col="{ span: 14 }"
        >
          <span>{{partnerform.subjectName}}</span>
        </a-form-item>
         <a-form-item
          label="是否通过"
          :wrapper-col="{ span: 14 }"
          :label-col="{ span: 4, offset: 1 }"
          name="available"
        >
          <a-radio-group v-model:value="partnerform.available">
            <a-radio value="1">是</a-radio>
            <a-radio value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          label="报名海报"
          name="subjectInfo"
          :label-col="{ span: 3, offset: 2 }"
          :wrapper-col="{ span: 14 }"
        >
          <div class="clearfix">
            <a-upload
              list-type="picture-card"
              :file-list="imgUrl"
              :customRequest="customRequestZip"
              :before-upload="beforeUploadZip"
              @preview="handlePreview"
              :remove="removeFile"
            >
              <div v-if="imgUrl !== null && imgUrl.length < 1">
                <plus-outlined />
                <div class="ant-upload-text">上传图片</div>
              </div>
            </a-upload>
            <a-modal
              :visible="imgVisible"
              :footer="null"
              :keyboard="true"
              :maskClosable="true"
              @cancel="showImg"
            >
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-item>
        <a-form-item :wrapper-col="{ offset: 8 }">
          <a-button style="margin-right:100px" @click="reset">重置</a-button>
          <a-button type="primary" @click="onSubmit">提交</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { options, provs } from "../../../assets/province.json";
import { allcities } from "../../../assets/province.json";
import { Modal, notification } from "ant-design-vue";
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {
          isAdd: true,
          isShow: false,
          isSee: false
        };
      }
    },
    certificateTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const validatePassScore = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入及格分数");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正整数");
      } else {
        return Promise.resolve();
      }
    };
    const validateValidity = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入证书有效期");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正整数");
      } else {
        return Promise.resolve();
      }
    };
    const validateEntryFee = async (rule, value, callback) => {
      if (value === "") {
        return Promise.reject("请输入报名费用");
      } else if (isNaN(Number(value))) {
        return Promise.reject("请输入数字");
      } else if (value < 0) {
        return Promise.reject("数字必须为正整数");
      } else {
        return Promise.resolve();
      }
    };
    const subjectInfoLength = async (rule, value, callback) => {
      if (value.length > 200) {
        return Promise.reject("课程描述最多200个字");
      } else {
        return Promise.resolve();
      }
    };
    return {
      rule5: {
        subjectNo: [
          { required: true, message: "请输入课程编号", trigger: "blur" }
        ],
        subjectName: [
          { required: true, message: "请输入考试课程名称", trigger: "blur" }
        ],
        passScore: [
          { required: true, validator: validatePassScore, trigger: "blur" }
        ],
        validity: [
          { required: true, validator: validateValidity, trigger: "blur" }
        ],
        entryFee: [
          { required: true, validator: validateEntryFee, trigger: "blur" }
        ],
        certificateTypeId: [
          {
            required: true,
            message: "请选择考试认证类型"
            // trigger: "change"
          }
        ],
        subjectInfo: [
          {
            validator: subjectInfoLength,
            trigger: "blur"
          }
        ]
      },
      fileList: [],
      imgUrl: [],
      previewVisible: false,
      acceptTypeEquipZip: ["jpg", "jpeg", "png", "gif"],
      fileCode: "",
      previewImage: "",
      partnerform: {
        subjectNo: "",
        subjectName: "",
        certificateTypeId: "",
        passScore: 60,
        validity: 100,
        entryFee: 0,
        subjectInfo: "",
        id: ""
      },
      locale: {
        lang: {
          placeholder: "请选择日期",
          today: "今天",
          yearFormat: "YYYY",
          dateFormat: "M/D/YYYY",
          dayFormat: "D",
          dateTimeFormat: "M/D/YYYY HH:mm:ss",
          monthFormat: "MMMM",
          ok: "确定",
          timeSelect: "选择时间",
          dateSelect: "选择日期",
          now: "现在",
          selectTime: "选择时间",
          selectDate: "选择日期"
        }
      }
    };
  },
  mounted() {
    console.log("...");
  },
  computed: {},
  watch: {},
  methods: {
    handleChange(value) {
      console.log(`selected ${value}`);
    },
    filterOption(input, option) {
      return option.children[0].children.indexOf(input) !== -1;
    },
    // 重置
    reset() {
      // this.temp();
    },
    onSubmit() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self = this;
      const obj = Object.assign(self.partnerform);
      let funStr = "";
      let msg = "";
      this.certificateTypeList.forEach(item => {
        if (obj.certificateTypeId === item.id) {
          obj.certificateTypeName = item.typeName;
        }
      });
      if (obj.id === "") {
        // obj.createTime = new Date();
        obj.attachmentCode = this.fileCode;
        obj.passScore = String(obj.passScore);
        funStr = "SaveExamSubject";
        msg = "添加成功";
      } else {
        funStr = "UpdateExamSubject";
        msg = "修改成功";
      }
      this.$refs.partnerform
        .validate()
        .then(() => {
          self.$store
            .dispatch(funStr, obj)
            .then(res => {
              if (res.code === 0) {
                notification["success"]({
                  message: msg
                });
                this.info.isShow = false;
                this.temp();
                // this.$emit("getList");
              } else {
                self.$handleErr(res);
              }
            })
            .catch(err => {
              self.$handleErr(err);
            });
        })
        .catch(error => {
          return false;
        });
    },
    // 设置行数据
    setRowData(rowData) {
      this.partnerform = rowData;
      this.getFile(rowData.attachmentCode);
    }
  },
  components: {},
  filters: {}
};
</script>
<style lang="scss" scoped></style>
